// Idiomas soportados por Voicit. La clave es el código de locale (denominación) tal cual
// llega del backend (es-ES, ca-ES...) y el valor el nombre completo en español para el tooltip.
export const languageNames = {
  'es-ES': 'Español',
  'en-GB': 'Inglés',
  'ca-ES': 'Catalán',
  'fr-FR': 'Francés',
  'de-DE': 'Alemán',
  'it-IT': 'Italiano',
  'pt-PT': 'Portugués',
  'ja-JP': 'Japonés',
  'eu-ES': 'Euskera',
};

// Nombre completo para el tooltip; si no lo conocemos, devolvemos el código tal cual.
export const languageName = (code) => languageNames[code] || code;
